import plugin from "js-plugin";

class CollapsibleSection {
    constructor($node) {
        this.$node = $node;
        this.$contents = $node.querySelectorAll('.content');
        this.$button = $node.querySelector('.collapse-button');
        this.$title = $node.querySelector('.title');
        this.$button_container = $node.querySelector('.collapse-button-container');
        this.$collapse_button_text = $node.querySelector('.collapse-button-text')
        this.collapsed = false;

        // also add event listener to title to improve UX
        this.$title.addEventListener('click', this.toggleCollapse.bind(this));

        if (this.$button_container) {
            this.$button_container.addEventListener('click', this.toggleCollapse.bind(this));
        } else if (this.$button) {
            this.$button.addEventListener('click', this.toggleCollapse.bind(this));
        }
        window.addEventListener('resize', this.handleResize.bind(this));
    }

    toggleCollapse() {
        if (this.collapsed) {
            for (const content of this.$contents) {
                content.style.maxHeight = `1000px`;
                content.classList.remove("hidden")
            }
            this.$node.classList.remove('collapsed');
            if (this.$collapse_button_text) {
                this.$collapse_button_text.classList.add("hidden")
            }
        } else {
            for (const content of this.$contents) {
                if (content.style) {
                    content.style.maxHeight = null;
                    content.classList.add("hidden")
                }

            }
            this.$node.classList.add('collapsed');
            if (this.$collapse_button_text) {
                this.$collapse_button_text.classList.remove("hidden")
            }
        }
        this.collapsed = !this.collapsed;
    }

    handleResize() {
        // Adjust the maxHeight on resize only if the section is not collapsed
        if (!this.collapsed) {
            for (const content in this.$contents) {
                content.style.maxHeight = `${content.scrollHeight}px`;
                this.$collapse_button_text.classList.remove("hidden")
            }
        }
    }

    loaded() {
        // Initialize the section as collapsed
        this.toggleCollapse();
    }
}

const CollapsibleSectionPlugin = {
    name: 'CollapsibleSection',
    initializeWithSelector: ($node) => {
        const c = new CollapsibleSection($node);
        c.loaded();
    }
};

// Register plugin
plugin.register(CollapsibleSectionPlugin);